export default () => {
  const orientationModal = document.querySelector('.orientation-modal');
  const mediaQueryList = window.matchMedia('(orientation: portrait)');

  toggleOrientationModal();
  window.addEventListener('orientationchange', toggleOrientationModal);

  function toggleOrientationModal() {
    setTimeout(() => {
      if (mediaQueryList.matches && detectMob()) {
        hideModal();
      } 
      
      if (!mediaQueryList.matches && detectMob()) {
        if(window.innerWidth < 700 || window.innerHeight < 700) {
          showModal();
        }
      }
    }, 300);
  }

  function showModal() {
    orientationModal.classList.add('show');
    document.body.style.overflow = 'hidden';
  }

  function hideModal() {
    orientationModal.classList.remove('show');
    document.body.style.overflow = '';
  }

  function detectMob() {
    const toMatch = [/Android/i, /webOS/i, /iPhone/i, /iPod/i, /BlackBerry/i, /Windows Phone/i];

    return toMatch.some((toMatchItem) => {
      return navigator.userAgent.match(toMatchItem);
    });
  }
};
